import { Button, FormControlLabel, Grid, TextField } from "@mui/material";
import Switch from "@mui/material/Switch";

import { DateRangePicker } from "../share-component/data-range-picker";
import { MultiSelectFormControl } from "../share-component/multi-select";

export const CustomDatasetFilters = ({
  values,
  handleChange,
  handleSubmit,
  definitions,
  time,
  setTime,
  setFieldValue,
  setQueryFilterState,
  resetForm,
  presetRange,
  setPresetRange,
  initialQueryFilterState,
  queryFilterState,
  localStorageKey,
}: any) => {
  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          id="query"
          name="query"
          label="Search"
          type="text"
          size="small"
          value={values.query}
          onChange={(e: any) => {
            handleChange(e);
            handleSubmit();
          }}
          variant={"outlined"}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MultiSelectFormControl
          id={"name"}
          label={"Name"}
          options={definitions.isSuccess ? definitions.data.names : []}
          value={values.name}
          handleSubmit={handleSubmit}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        md={3}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <DateRangePicker
          time={time}
          setTime={setTime}
          setFieldValue={setFieldValue}
          handleSubmit={handleSubmit}
          presetRange={presetRange}
          setPresetRange={setPresetRange}
          disabled={values.latestRelease}
          queryFilterState={queryFilterState}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm="auto"
        md="auto"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={values.latestRelease}
              onChange={(e: any) => {
                handleChange(e);
                handleSubmit();
              }}
              id={"latestRelease"}
              name={"latestRelease"}
            />
          }
          label={`Latest Release`}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm="auto"
        md="auto"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <Button
          variant="text"
          size="small"
          color="info"
          id="clearFilters"
          name="clearFilters"
          onClick={() => {
            setTime({ startTime: 0, endTime: 0 });
            setFieldValue("release", "");
            localStorage.removeItem(localStorageKey);
            setQueryFilterState(initialQueryFilterState);
            resetForm();
            handleSubmit();
          }}
        >
          Clear
        </Button>
      </Grid>
    </Grid>
  );
};
